import { render, staticRenderFns } from "./SubstituteList.vue?vue&type=template&id=29596318&"
import script from "./SubstituteList.vue?vue&type=script&lang=ts&"
export * from "./SubstituteList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports